import React from 'react';
import { Link } from 'react-router-dom';

import { urlJoin } from '../../utils/url-utils';
import './minicard.css';

export default class MiniCard extends React.Component {
    render() {
        const {
            card: miniCard,
            url,
            finished,
            onDelete,
        } = this.props;
        return (
            <div className='minicard'>
                <div className='minicard-img'>
                    <img src={miniCard.picture} alt={miniCard.title}/>
                </div>
                <div className='minicard-foreground'>
                    <span className='minicard-title'>{miniCard.title}</span>

                    <Link to={urlJoin(url, miniCard.id)}>
                        <button className={'minicard-btn ' + (finished ? 'minicard-finished' : '')}>
                            {finished ? 'Preenchido' : 'Responder'}
                        </button>
                    </Link>

                </div>
                <div className='edition-toolbar' title='Deletar item'>
                    <a onClick={onDelete}>
                        <i className='fa fa-trash'/>
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/minicard/minicard.js